import { formatDollars } from "@common/components/utils";
import { StipendWalletResponse } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";

export const ProgressBar = (props: {
  stipend: StipendWalletResponse;
  isInactive?: boolean;
}) => {
  const { stipend, isInactive = false } = props;

  return (
    <div>
      <Body size="sm" weight="regular" className="text-white/50">
        Total Budget
      </Body>
      <div className="mt-3 h-[6px] w-[300px] rounded-lg bg-[#232323]">
        <div
          className={`z-50 h-[6px] rounded-lg ${isInactive ? "bg-gray" : "bg-white"}`}
          style={{
            width:
              (stipend?.startingBalance > 0
                ? stipend?.remainingBalance / stipend?.startingBalance
                : 0) *
                100 +
              "%",
          }}
        />
      </div>
      <Body size="md" weight="regular" className="pt-2 text-white/50">
        {formatDollars(stipend?.remainingBalance)} of{" "}
        {formatDollars(stipend?.startingBalance)} remaining
      </Body>
    </div>
  );
};
